// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"88f1c71d","86":"e01b75e1","346":"fa384981","411":"f0e96118","433":"34ef834e","496":"510dd53f","622":"edc0640b","816":"7de90ee1","963":"0ec2d658"}[chunkId] + ".chunk.js";
};